import { Component, Input } from '@angular/core';
import { Service } from 'src/app/shared/models/service';

@Component({
  standalone: false,
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: [],
})
export class ServiceCardComponent {
  @Input() service: Service;
}
